import React from "react";
import { connect } from "react-redux";
import SignatureBlockConfigurationPage from "./SignatureBlockConfigurationPage";
import { UserWithPersonWithOrganizationPersons } from "../../../api/types";

type SignatureBlockConfigurationRouterProps = {
  token: string;
  orgId: number;
  dealId: number;
  dealLegalEntityId: number;
};

const SignatureBlockConfigurationRouter = ({
  token,
  orgId,
  dealId,
  dealLegalEntityId,
}: SignatureBlockConfigurationRouterProps) => {
  return (
    <SignatureBlockConfigurationPage
      token={token}
      orgId={orgId}
      dealId={dealId}
      dealLegalEntityId={dealLegalEntityId}
    />
  );
};

const mapStateToProps = (
  state: {
    auth: {
      user: UserWithPersonWithOrganizationPersons;
      token: string;
    };
  },
  props: {
    match: {
      params: {
        dealId: string;
        orgId: string;
        dealLegalEntityId: string;
      };
    };
  }
) => {
  const {
    match: {
      params: { dealId, orgId, dealLegalEntityId },
    },
  } = props;
  const { user, token } = state.auth;

  return {
    user,
    token,
    dealId: parseInt(dealId),
    orgId: parseInt(orgId),
    dealLegalEntityId: parseInt(dealLegalEntityId),
  };
};

export default connect(mapStateToProps)(SignatureBlockConfigurationRouter);
